export default __webpack_public_path__ + "assets/a79c6a29bdeafd775b5cff0f543ac87d.png";